import { render, staticRenderFns } from "./RegisterProfessional.vue?vue&type=template&id=4bacec47&"
import script from "./RegisterProfessional.vue?vue&type=script&lang=js&"
export * from "./RegisterProfessional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports